import React from 'react'
import { Field } from 'redux-form'
import { InputWithIcon } from '../../../../../../../../../../itrust_common/components/form'

export default function SpecteraBillAmountField({ name, wrapperClasses = 'form-group col-3', disabled = false }) {
  return (
    <Field
      name={name}
      component={InputWithIcon}
      title="$"
      className="form-control"
      wrapperClasses={wrapperClasses}
      disabled={disabled}
    />
  )
}
